import { EMPTY } from "lib/constants";

export const truncateText = (text: string, maxLength: number) => {
  if (text?.length > maxLength) {
    return text?.slice(0, maxLength) + "...";
  }
  return text;
};

export const isEmpty = (value: string): boolean =>
  value === null || value === undefined || value.trim() === EMPTY;

export const getClinicShortCode = (clinicName: string) => {
  return clinicName
    .split(/\s+/)               // split by space(s)
    .map((word) => word[0])     // take first letter of each word
    .join('')                   // join them
    .toUpperCase();             // uppercase
};
